function Ctrl($scope, $panelInstance, integration, integrationType, venue, organizationService, organizationIntegrationService, alertService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.integration = integration;
  $scope.integrationType = integrationType;
  $scope.venue = venue;
  $scope.saving = false;
  $scope.submitted = false;

  $scope.integrationForm = {
    enabled: $scope.integration && $scope.integration.status === 'ACTIVE' || !$scope.integration,
    bitly: {
      key: null
    },
    insightly: {
      key: null
    },
    mailchimp: {
      key: null
    },
    yelp: {
      id: null,
      url: null
    }
  };

  if ($scope.integration && $scope.integration.type === 'BITLY') {
    $scope.integrationForm.bitly.key = $scope.integration.bitly.key;
  } else if ($scope.integration && $scope.integration.type === 'INSIGHTLY') {
    $scope.integrationForm.insightly.key = $scope.integration.insightly.key;
  } else if ($scope.integration && $scope.integration.type === 'MAILCHIMP') {
    $scope.integrationForm.mailchimp.key = $scope.integration.mailchimp.key;
  } else if ($scope.integration && $scope.integration.type === 'YELP' && $scope.integration.yelp) {
    if ($scope.integration.yelp.id) $scope.integrationForm.yelp.id = $scope.integration.yelp.id;
    if ($scope.integration.yelp.url) $scope.integrationForm.yelp.url = $scope.integration.yelp.url;
  }

  $scope.closePanel = function ($event) {
    if ($event) $event.preventDefault();

    $panelInstance.close(false);
  };

  $scope.saveIntegration = function (form) {
    $scope.submitted = true;

    if (form && !form.$valid) return;

    $scope.saving = true;

    const promise = $scope.integration ?
      organizationIntegrationService.updateByIdAndOrganizationId($scope.integration.id, currentUserOrganization.id, {
        status: $scope.integrationForm.enabled ? 'ACTIVE' : 'INACTIVE',
        bitly: $scope.integrationForm.bitly,
        insightly: $scope.integrationForm.insightly,
        mailchimp: $scope.integrationForm.mailchimp,
        yelp: {
          url: $scope.integrationForm.yelp.url
        }
      }) :
      organizationIntegrationService.createByOrganizationId(currentUserOrganization.id, {
        venueId: venue.id,
        type: $scope.integrationType.type,
        status: $scope.integrationForm.enabled ? 'ACTIVE' : 'INACTIVE',
        bitly: $scope.integrationForm.bitly,
        insightly: $scope.integrationForm.insightly,
        mailchimp: $scope.integrationForm.mailchimp,
        yelp: {
          url: $scope.integrationForm.yelp.url
        }
      });

    promise.then(result => {
        $panelInstance.close({
          new: !$scope.integration,
          integration: result.data
        });
      })
      .catch((err) => {
        $scope.saving = false;
        console.log(err);
        const msg = (err && err.data && err.data.errors.length) ? err.data.errors[0].message : 'There was an error updating your integration';
        // alertService.error(err);
        alertService.error(msg);
      });
  };
}

Ctrl.$inject = [
  '$scope',
  '$panelInstance',
  'integration',
  'integrationType',
  'venue',
  'organizationService',
  'jsSdk.organizationIntegration',
  'alertService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/panels/addIntegration/controller.js